const initSelectCustomDropdown = () => {
  document
    .querySelectorAll("select.custom-dropdown-native:not([data-enhanced])")
    .forEach(function (select) {
      // Create a wrapper div for the custom dropdown
      const wrapper = document.createElement("div");
      const size = select.getAttribute("data-size") || "";
      const transparent = select.getAttribute("data-transparent") || "";
      wrapper.className = `custom-dropdown ${
        size ? `custom-dropdown--${size}` : ""
      } ${transparent ? "custom-dropdown--transparent" : ""}`;
      if (select.id) wrapper.id = select.id + "-custom";

      // Copy options to divs with data-value
      Array.from(select.options).forEach(function (option) {
        if (option.value !== "") {
          // skip placeholder if needed
          const div = document.createElement("div");
          div.setAttribute("data-value", option.value);
          div.textContent = option.textContent;
          wrapper.appendChild(div);
        }
      });

      // Insert the custom dropdown after the select
      select.parentNode.insertBefore(wrapper, select.nextSibling);

      // Optionally hide the original select
      select.style.display = "none";

      // Get label from data-label attribute
      const label = select.getAttribute("data-label") || null;

      // Get the currently selected option from the original select
      const selectedOption = select.options[select.selectedIndex];
      const hasSelectedValue = selectedOption && selectedOption.value !== "";
      
      // Determine initial value and text for the custom dropdown
      const initialValue = hasSelectedValue ? selectedOption.value : null;
      const initialText = hasSelectedValue ? selectedOption.textContent : (select.options[0]?.textContent || "Select an option");

      // Initialize the custom dropdown
      initCustomDropdown("#" + wrapper.id, {
        placeholder: initialText,
        label: label, // <-- use the label from data-label
        initialValue: initialValue, // <-- set initial selected value
        onSelect: (value, text) => {
          // Sync value back to the original select
          select.value = value;
          // Optionally trigger change event
          select.dispatchEvent(new Event("change", { bubbles: true }));
        },
      });

      select.setAttribute("data-enhanced", "true");
    });
};

document.addEventListener("DOMContentLoaded", function () {
  initSelectCustomDropdown();
});
